import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useDialog } from '@zep/dialog';
import { usePlanSpaceDetail, useUnsubscribePlan } from '../../../../services';
import { fDateTimeByCountryCode } from '../../../../utils';
import { INFINITE_MAX_CCU } from '../SubscriptionConst';
export const useCancelSubscription = (spaceHashId: string) => {
  const router = useRouter();
  const {
    mutateAsync: 구독취소
  } = useUnsubscribePlan(spaceHashId);
  const {
    t
  } = useTranslation(['subscription']);
  const dialog = useDialog();
  const {
    data: {
      spacePlan,
      space
    }
  } = usePlanSpaceDetail(router.query.id as string);
  const peopleUnlimited = t('subscription:pricing.plansEnterprise.peopleUnlimited');
  const handleClickCancel = async ({
    onSuccess
  }: {
    onSuccess: () => void;
  }) => {
    if (!spacePlan) return;
    const cancel = await dialog.confirm({
      confirmVariant: 'alert',
      title: t('subscription:SpaceDetail.alertSubscriptionCancel.title'),
      content: t(spacePlan.saleType ? 'subscription:SpaceDetail.alertSubscriptionCancel.saleDescription' : 'subscription:SpaceDetail.alertSubscriptionCancel.saleDescription', {
        spaceName: space.name,
        plan: spacePlan.planType,
        ccu: spacePlan.maxCcu === INFINITE_MAX_CCU ? peopleUnlimited : spacePlan.maxCcu
      })
    });
    logger.track('home_subscription_cancel');
    if (!cancel) return;
    try {
      await unsubscribe({
        onSuccess
      });
    } catch (error) {
      console.log(error);
      await dialog.alert({
        title: t('subscription:SpaceDetail.unsubscribeFailure.title'),
        content: t('subscription:SpaceDetail.unsubscribeFailure.content')
      });
    }
  };
  const unsubscribe = async ({
    onSuccess
  }: {
    onSuccess: () => void;
  }) => {
    const res = await 구독취소();
    if (res.status >= 0) {
      onSuccess();

      // 결제 실패 상태의 플랜의 구독취소 완료 모달 컨텐츠는 nextCreationDate를 보여주지 않도록 합니다.
      await dialog.alert({
        title: t('subscription:SpaceDetail.alertCancelSuccess.title'),
        content: (spacePlan?.paymentFailCount ?? 0) > 0 ? t('subscription:SpaceDetail.alertCancelSuccess.failPlanDescription') : t('subscription:SpaceDetail.alertCancelSuccess.description', {
          expiredDate: fDateTimeByCountryCode(res.data?.nextCreationDate, space.countryCode)
        }),
        confirmText: t('subscription:SpaceDetail.alertCancelSuccess.confirm')
      });
      void router.push(`/me/spaces/${spaceHashId}/plan`);
    }
  };
  return {
    handleClickCancel
  };
};